export default function getResource(label) {
    const resources = {
        noSamplesInStock: 'Aucun échantillon n’est en stock pour le moment.'
    };

    return resources[label];
}
